<template>
  <div>
    <el-table ref="elTable" border :data="tableList" style="width: 100%">
        <el-table-column prop="outerOrderNo" :label="$t('InternalSalesOrderDetails.party')" align="center" min-width="200" />
        <!-- <el-table-column prop="innerOrderNo" :label="$t('OrdinaryOrderMix.LogisticsTable.innerOrderNo')" align="center" width="248" /> -->
        <el-table-column prop="logisticsNo" :label="$t('OrdinaryOrderMix.LogisticsTable.logisticsNo')" align="center" min-width="200">
          <template slot-scope="scope">
            <!-- <span>{{ scope.row.logisticsNo }}</span> -->
            <span class="link" @click="openTrackingDetails(scope.row)">{{ scope.row.logisticsNo }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="logisticsCompany" :label="$t('OrdinaryOrderMix.LogisticsTable.logisticsCompany')" align="center" min-width="200"/>
        <el-table-column prop="logisticsBusinessName" :label="$t('OrdinaryOrderMix.LogisticsTable.logisticsBusinessName')" align="center" min-width="200" />
        <el-table-column v-if="!$store.getters.cusId" prop="totalCharge" :label="$t('OrdinaryOrderMix.LogisticsTable.totalPrice')" align="center" min-width="200" >
          <template slot-scope="scope">{{ scope.row.totalCharge ? (scope.row.totalCharge-0).toFixed(2) : scope.row.totalCharge }}</template>
        </el-table-column>
    </el-table>
    <DeliverDialog ref="DeliverDialogRef"/>
  </div>
</template>
<script>
import { afterApi } from '@/api';
import { events_config } from '@/utils';
import DeliverDialog from './DeliverDialog.vue';

export default {
  name: '',
  components: { DeliverDialog },
  data() {
    return {
      tableList: [],
    };
  },
  created() {
    this.getLogisticsInfo();
  },
  methods: {
    getLogisticsInfo() {
      afterApi.logisticsGetInfo({
        innerOrderNo: this.$route.query.code
      })
      .then(res => 	{
        if (!res.failed) {
          if(!res.innerOrderNo &&!res.outerOrderNo &&!res.logisticsNo ){
            this.tableList = [];
          }else{
            this.tableList = [res];
            this.$emit('haveLogistics', res);
            events_config.trigger('getLogisticsEvent', res);
          }
        } else {
          this.tableList = [];
        }
      });
    },
    // 根据物流单号获取弹框数据并打开弹窗
    openTrackingDetails(row){
      this.$refs.DeliverDialogRef.show(row)
    },
    doLayout() {
      this.$refs.elTable && this.$refs.elTable.doLayout();
    },
  },
};
</script>
